import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum BalanceAdjustmentType {
  credit = 'credit',
  debit = 'debit',
}

export default class BalanceAdjustmentModel extends Model {
  @attr('number') amount!: number;
  @attr('string') note!: string;
  @attr('string') type!: BalanceAdjustmentType;
  @attr('date') createdAt!: Date;

  @belongsTo('booking', {
    inverse: 'balanceAdjustments',
    async: false,
  })
  booking!: ModelRegistry['booking'];

  @cached
  get adjustedAmount(): number {
    return this.amount;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'balance-adjustment': BalanceAdjustmentModel;
  }
}
